import { useState, useEffect } from 'react';

import { TextField } from 'react-admin';

import { flowchartLogger } from 'src/lib/logger';

import ResourceList from '../../components/ResourceList';
import NodeControlForm from '../NodeControlForm';

import type { NodeControlsProps } from '../../dataProvider/types';
import type { ConferenceRead } from '@ragu-components/ord-types';

export interface ConferenceType extends Record<string, unknown> {
  conference: ConferenceRead | null;
}

interface ConferenceControlsProps extends NodeControlsProps {
  updateNodeData: (data: Record<string, unknown>) => void;
  data: ConferenceType;
}

export default function ConferenceControls({ updateNodeData, data }: ConferenceControlsProps): React.ReactElement {
  const [conference, setConference] = useState<ConferenceRead | null>(data.conference ?? null);

  const onConferenceDataUpdate = (event: React.MouseEvent | React.FormEvent): void => {
    event.preventDefault();
    flowchartLogger.debug('ConferenceControls: onConferenceDataUpdate', { conference });
    if (conference === undefined || conference === null) {
      flowchartLogger.debug('ConferenceControls: conference is undefined or empty. Update cancelled.');
      return;
    }
    updateNodeData({ conference });
  };

  useEffect(() => {
    flowchartLogger.debug('ConferenceControls: autosave', { conference });
    updateNodeData({ conference });
  }, [conference, updateNodeData]);

  return (
    <NodeControlForm
      onSubmit={onConferenceDataUpdate}
      isDisabled={conference === undefined || conference === null}
      data={data}
      updateNodeData={updateNodeData}
    >
      <ResourceList
        resource='conferences'
        selectedResourceId={conference !== null ? conference.id : null}
        onRowClick={(_id, _resource, record) => {
          flowchartLogger.debug('ConferenceControls: onRowClick', { record });
          setConference(record as ConferenceRead);
          return false;
        }}
      >
        <TextField source={'name'} />
      </ResourceList>
    </NodeControlForm>
  );
}
